import type { AudienceRuleUserExportSms } from '@shared/api/rtkQuery'

export const isAudienceRuleUserExportSms = (
  payload: unknown
): payload is AudienceRuleUserExportSms =>
  (payload as AudienceRuleUserExportSms).sendType !== ''
